import * as React from 'react';
import * as ReactDOM from 'react-dom';

let annoucementCounter = 0;

interface Props {
  children: string | undefined | null;
}

/**
 * An a11y helper that allows a component to add an ARIA live region
 * while it is rendered.
 *
 * @see https://www.w3.org/TR/wai-aria-1.1/#attrs_liveregions
 */
export function Announcement({ children }: Props) {
  const [container, setContainer] = React.useState<HTMLElement>(null);

  React.useEffect(() => {
    const element = document.createElement('div');
    element.setAttribute('id', `annoucement-container-${annoucementCounter++}`);
    element.setAttribute('class', 'sr-only');
    element.setAttribute('aria-live', 'polite');
    element.setAttribute('aria-atomic', 'true');

    document.body.appendChild(element);
    setContainer(element);

    return () => {
      document.body.removeChild(element);
    };
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(children, container);
}
